import { render } from "./ButtonIconSlot.vue?vue&type=template&id=17cc11ec&scoped=true&ts=true"
import script from "./ButtonIconSlot.vue?vue&type=script&lang=ts"
export * from "./ButtonIconSlot.vue?vue&type=script&lang=ts"

import "./ButtonIconSlot.vue?vue&type=style&index=0&id=17cc11ec&lang=postcss&scoped=true"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17cc11ec"]])

export default __exports__